export default "__VITE_ASSET__CQfMbfzB__"